const CHECKBOX_TYPES = new Set(["checkbox", 7, "7"]);

export function isCheckboxField(field) {
	if (!field) return false;
	const type = field.fieldType ?? field.type;
	if (type == null) return false;
	return CHECKBOX_TYPES.has(type) || String(type).toLowerCase() === "checkbox";
}

export function checkboxOptionLabel(field) {
	if (!field) return "Checkbox";
	const title = String(field.fieldTitle || field.title || field.label || "").trim();
	return title || "Checkbox";
}

/** Parent question for a checkbox option, or "" if the field is only "Yes"/"No". */
export function checkboxChoiceGroup(field) {
	if (!isCheckboxField(field)) return "";
	const option = checkboxOptionLabel(field);
	const question = String(
		field.fieldDescription || field.placeholder || field.choiceGroup || ""
	).trim();
	if (!question) return "";
	if (question.toLowerCase() === option.toLowerCase()) return "";
	return question;
}
